module.exports = __webpack_public_path__ + "img/carrousel-intervensionista-10.89508e7a.png";